module.exports = __webpack_public_path__ + "img/portfolio4.70e2f3d2.jpg";